import { Injectable } from '@angular/core';
import { UrlService } from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { DcBaseRequester } from './dc-base.requester';
import { IJobTracking } from './models/job-tracking';

@Injectable({
	providedIn: 'root',
})
export class DataFrameRequester extends DcBaseRequester<IJobTracking> {
	protected resource;
	protected elementsListUrl;
	protected singleElementUrl;
	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('DATAFRAME_PERSIST');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
	}

	public persist(code: string): Observable<IJobTracking> {
		const url = this.urlService.generateUrl(
			this.resource,
			{
				code,
			},
			{
				project: this.projectId,
			}
		);
		return this.get<IJobTracking>(url);
	}

	public repersist(code: string): Observable<IJobTracking> {
		const resourceUrl = this.generateResourceUrl('DATAFRAME_REPERSIST');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{
				code,
			},
			{
				project: this.projectId,
			}
		);
		return this.get<IJobTracking>(url);
	}

	public unpersist(code: string): Observable<IJobTracking> {
		const resourceUrl = this.generateResourceUrl('DATAFRAME_UNPERSIST');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{
				code,
			},
			{
				project: this.projectId,
				ctx: this.projectStorage.getSelectedContext(),
			}
		);
		return this.get<IJobTracking>(url);
	}
}
